import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarLeadsByIdService } from "../../../services/buscarLeadsByIdService";

export const useBuscarLeadsById = (
  leadId: number | undefined | null,
  fetch: boolean
) => {
  const [leads, setLeads] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as leads
  useEffect(() => {
    const fetchLead = async () => {
      if (leadId && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarLeadsByIdService(leadId);
          if (data) {
            setLeads(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar Leads:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [leadId, fetch]);

  return { leads, isLoading };
};
